import { IPaginationMeta } from "../paginationParam.type"

export enum CompanyType {
  INTERNAL = "internal",
  EXTERNAL = "external",
}

export interface ICompany {
  type: CompanyType
  code: string
  name: string
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export interface ICompanyResponse {
  items: ICompany[]
  meta: IPaginationMeta
}
